// Used a separate file for bundling

export function isFontFamiliesPanelSupported(
	zone: eXpress.core.IZone | undefined,
	dashboard: eXpress.TextZoneDashboard,
) {
	return dashboard.canSetFontFamily(zone);
}
